// features/finances/presupuestoIngresosApi.ts
// PRESUPUESTO DE INGRESOS OBJETIVO + copiar periodo (B2 ampliado, 25-oct-2026; Mabel 23-oct «presupuestos del siguiente
// semestre»). Captura en Finanzas › Presupuesto › Ingresos; Reportes › Presupuesto vs Real toma el objetivo capturado como
// presupuesto de esa fila. API: /finances/presupuesto/ingresos* y /finances/presupuesto/copiar-rango
// (lib/letsmovePresupuestoIngresos.js). Archivo aparte de api.ts como presupuestoGastosApi.ts.
import { api } from '../../services/apiClient';
import type { OrigenCelda } from './presupuestoGastosApi';

export type CatKey = 'mensualidad' | 'pago_tardio' | 'inscripcion' | 'particular' | 'suelta' | 'evento' | 'producto' | 'otro';

export interface PICelda { amount: number; origen: OrigenCelda; desde?: string | null; note?: string | null }
export interface PIOperativo { amount: number; origen: string; n?: number }
export interface PIFila {
  k: CatKey; categoria: string; concepto: string;
  celdas: Record<string, PICelda | null>;           // objetivo capturado (o heredado) por mes
  operativo: Record<string, PIOperativo | null>;    // lo que calcula el sistema
  real: Record<string, number | null>;              // devengado; null en meses futuros
}
export interface PICuadricula {
  disponible: boolean; aviso: string | null; desde: string;
  meses: { mes: string; titulo: string; enCurso: boolean; futuro: boolean }[];
  filas: PIFila[];
  totales: { objetivo: Record<string, number>; operativo: Record<string, number>; real: Record<string, number | null> };
  alumnas: number; notas: string[];
}
export interface PIComparativoFila {
  k: CatKey; categoria: string; concepto: string;
  objetivo: number | null; origenObjetivo: OrigenCelda | null; note: string | null;
  operativo: number | null; origenOperativo: string | null; real: number | null;
  diferencia: number | null; pct: number | null; difOperativo: number | null;
}
export interface PIComparativo {
  mes: string; titulo: string; enCurso: boolean; futuro: boolean; pasado: boolean;
  disponible: boolean; aviso: string | null; vacio: boolean;
  filas: PIComparativoFila[];
  totales: { objetivo: number; operativo: number; real: number | null; diferencia: number | null; pct: number | null; realConObjetivo: number | null };
  notas: string[]; generado: string;
}
export interface CopiaRango { ok: boolean; cambiados: number; meses: { de: string; a: string; cambiados: number }[]; desde: string; hasta: string; a: string; hastaDestino: string }

export function getCuadriculaIngresos(desde: string, n = 6) { return api.get<PICuadricula>(`/finances/presupuesto/ingresos/cuadricula?desde=${desde}&n=${n}`); }
export function getComparativoIngresos(month: string) { return api.get<PIComparativo>(`/finances/presupuesto/ingresos?month=${month}`); }
export function fijarMontoIngreso(b: { cat_key: CatKey; month: string; amount: number; modo: 'desde' | 'solo'; note?: string | null }) {
  return api.put<{ ok: boolean }>('/finances/presupuesto/ingresos/monto', b);
}
export function quitarMontoIngreso(cat_key: CatKey, month: string) {
  return api.del<{ ok: boolean }>(`/finances/presupuesto/ingresos/monto?cat_key=${cat_key}&month=${month}`);
}
export function copiarMesAnteriorIngresos(month: string) {
  return api.post<{ ok: boolean; cambiados: number; desde: string }>('/finances/presupuesto/ingresos/copiar', { month });
}
/** Copia `n` meses desde `desde` al periodo que empieza en `a` (gastos o ingresos). Origen y destino no se traslapan. */
export function copiarRangoPresupuesto(tipo: 'gastos' | 'ingresos', b: { desde: string; n: number; a: string }) {
  return api.post<CopiaRango>('/finances/presupuesto/copiar-rango', { tipo, ...b });
}
